import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: 'https://cw40.comfort-works.com/api/',
  cache: new InMemoryCache(),
});

export default client;